import BoxStyled from '../../components/BoxStyled';

export default BoxStyled.extend`
  margin-bottom: 20px;
  padding: 0.75rem 1.5rem 1.5rem 1.5rem;
  > .row {
    margin-bottom: 0;
  }
`;
